import {Component, ChangeDetectorRef, Output, EventEmitter, Input, ViewChild, ElementRef} from '@angular/core';
import {UploadEvent, FileSystemFileEntry} from 'ngx-file-drop';
import {LogService} from "../../services/log.service";

@Component({
    selector: 'app-upload-files',
    templateUrl: './upload-files.component.html',
    styleUrls: ['./upload-files.component.scss']
})

export class UploadFilesComponent {

    public files = [];
    allFilesValid = true;

    invalidExtensions = [
        '.ade', '.adp', '.bat', '.chm', '.cmd', '.com', '.cpl', '.dll', '.dmg', '.exe', '.hta', '.ins', '.isp', '.jar',
        '.js', '.jse', '.lib', '.lnk', '.mde', '.msc', '.msi', '.msp', '.mst', '.nsh', '.pif', '.scr', '.sct', '.shb',
        '.sys', '.vb', '.vbe', '.vbs', '.vxd', '.wsc', '.wsf', '.wsh', '.cab', '.zip'
    ];

    excelExtensions = ['.xlsx', '.xls'];

    @Output() closeModal = new EventEmitter();
    @Output() uploadDone = new EventEmitter();

    @Input() isMultiple = false;
    @Input() invalidExtension = false;
    @ViewChild('fileInput') fileInput: ElementRef;

    constructor(
        private cdr: ChangeDetectorRef,
        private logService: LogService
    ) { }

    public dropped(event: UploadEvent) {
        for (const droppedFile of event.files) {

            // Is it a file?
            if (droppedFile.fileEntry.isFile) {
                const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
                fileEntry.file((file: File) => {
                    // Here you can access the real file
                    this.logService.printLog("Dropped file - ", droppedFile.relativePath, file);
                    this.files.push(file);
                    this.cdr.detectChanges();
                });
            }
        }
        setTimeout(() => {
            this.isAllFilesValid();
        }, 100);
    }

    public fileOver(event) {
        this.logService.printLog(event);
    }

    public fileLeave(event) {
        this.logService.printLog(event);
    }

    fileUpload(buttonFiles) {
        this.logService.printLog('buttonFiles', buttonFiles);
        this.files = [];
        for (const buttonFile of buttonFiles) {
            this.files.push(buttonFile);
        }
        this.isAllFilesValid();
    }

    hasExtension(fileName) {
        let exts = this.excelExtensions;
        if (this.invalidExtension) {
            exts = this.invalidExtensions;
            return !(new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName.toLowerCase());
        } else {
            return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName.toLowerCase());
        }
    }

    removeFile(index) {
        this.files.splice(index, 1);

        // Empties file input
        this.fileInput.nativeElement.value = "";
        this.isAllFilesValid();
    }

    isAllFilesValid() {
        let valid = true;

        for (let i = 0; i < this.files.length; i++) {
            if (!this.hasExtension(this.files[i].name)) {
                valid = false;
            }
        }

        this.allFilesValid = valid;
    }
}
